import { Button, Progress, Tag } from "antd";
import LottieIcon from "../components/shared/lottieIcon/LottieIcon";
import CustomPopover from "../components/shared/custompopover/CustomPopover";
import { MoreOutlined } from "@ant-design/icons";
import viewIcon from "../assets/icons/Eye.svg";
import deleteIcon from "../assets/icons/Delete.svg";
import reportIcon from "../assets/icons/AssetReport.svg";
import editIcon from "../assets/icons/Edit.svg";
import CustomButton from "../components/global/Button/CustomButton";
import { formatDate, renderStatus } from "./commonConstant";
import { EyeOutlined } from "@ant-design/icons";
import optionsIcon from "../assets/icons/Options.svg"
import { formatPercentage, StatusTag } from "../assets/utils/reportUtils";

export const columns = (handleViewUserClick) => [
  {
    title: "Employee Id",
    dataIndex: "username",
    key: "username",
    width: 200,
    sorter: (a, b) => (a.username || "").localeCompare(b.username || ""),
  },
  {
    title: "Name",
    dataIndex: "fullName",
    key: "fullName",
    width: 150,
    sorter: (a, b) => a.fullName.localeCompare(b.fullName),
    render: (text, record) => (
      <Button
        type="link"
        style={{ color: "rgba(156, 38, 40, 1)" }}
        onClick={() => handleViewUserClick(record.userId, record.fullName)}
      >
        {text}
      </Button>
    ),
  },
  {
    title: "Email",
    dataIndex: "email",
    key: "email",
    width: 150,
    ellipsis: true,
    render: (text) => (
      <div
        style={{
          maxWidth: 150,
          whiteSpace: "nowrap",
          overflow: "hidden",
          textOverflow: "ellipsis",
        }}
        title={text}
      >
        {text}
      </div>
    ),
  },
  {
    title: "Role",
    dataIndex: "role",
    key: "role",
    width: 150,
    filters: [
      { text: "Manager", value: "MANAGER" },
      { text: "User", value: "USER" },
    ],
    onFilter: (value, record) =>
      record.role?.toLowerCase() === value.toLowerCase(),
  },
  {
    title: "Manager",
    dataIndex: "manager",
    key: "manager",
    width: 150,
    ellipsis: true,
    render: (text) => (
      <div
        style={{
          maxWidth: 150,
          whiteSpace: "nowrap",
          overflow: "hidden",
          textOverflow: "ellipsis",
        }}
        title={text}
      >
        {text}
      </div>
    ),
  },
  {
    title: "Assigned Courses",
    dataIndex: "assignedCourses",
    key: "assignedCourses",
    width: 150,
    sorter: (a, b) => a.assignedCourses - b.assignedCourses,
  },
  {
    title: "Completed Courses",
    dataIndex: "completedCourses",
    key: "completedCourses",
    width: 150,
    sorter: (a, b) => a.completedCourses - b.completedCourses,
  },
  {
    title: "In Progress Courses",
    dataIndex: "inProgressCourses",
    key: "inProgressCourses",
    width: 150,
    sorter: (a, b) => a.inProgressCourses - b.inProgressCourses,
  },
  {
    title: "Not Started Courses",
    dataIndex: "notStartedCourses",
    key: "notStartedCourses",
    width: 160,
    sorter: (a, b) => a.notStartedCourses - b.notStartedCourses,
  },
  {
    title: "Courses Completed On Time",
    dataIndex: "coursesCompletedOnTime",
    key: "coursesCompletedOnTime",
    width: 180,
    sorter: (a, b) => a.coursesCompletedOnTime - b.coursesCompletedOnTime,
  },
  {
    title: "Courses Completed Late",
    dataIndex: "coursesCompletedLate",
    key: "coursesCompletedLate",
    width: 180,
    sorter: (a, b) => a.coursesCompletedLate - b.coursesCompletedLate,
  },
  {
    title: "On Track Courses",
    dataIndex: "onTrackCourses",
    key: "onTrackCourses",
    width: 150,
    sorter: (a, b) => a.onTrackCourses - b.onTrackCourses,
  },
  {
    title: "Behind Schedule Courses",
    dataIndex: "behindScheduleCourses",
    key: "behindScheduleCourses",
    width: 180,
    sorter: (a, b) => a.behindScheduleCourses - b.behindScheduleCourses,
  },
  {
    title: "Courses Not Due Yet",
    dataIndex: "coursesNotDueYet",
    key: "coursesNotDueYet",
    width: 160,
    sorter: (a, b) => a.coursesNotDueYet - b.coursesNotDueYet,
  },
  {
    title: "Overdue Courses",
    dataIndex: "overdueCourses",
    key: "overdueCourses",
    width: 140,
    sorter: (a, b) => a.overdueCourses - b.overdueCourses,
  },
  {
    title: "Assigned Curriculums",
    dataIndex: "assignedCurriculum",
    key: "assignedCurriculum",
    width: 160,
    sorter: (a, b) => a.assignedCurriculum - b.assignedCurriculum,
  },
  {
    title: "Assigned Groups",
    dataIndex: "assignedGroups",
    key: "assignedGroups",
    width: 140,
    sorter: (a, b) => a.assignedGroups - b.assignedGroups,
  },
];

export const getGroupColumns = ({
  navigate,
  visiblePopover,
  setVisiblePopover,
  hoveredButton,
  setHoveredButton,
  handleViewGroupClick,
  handleOpenConfirmDeletePopup,
  handleViewGroupReportClick,
  handleEditGroupName,
  isActive
}) => [
  {
    dataIndex: "groupName",
    title: <div className="">Group Name</div>,
    key: "groupName",
    width: "43.33%",
    align:"left",
    onCell: () => ({ className: "table-cell-padded" }),
    onHeaderCell: () => ({ className: "table-cell-padded" }),
  },
  {
    dataIndex: "creatorName",
    title: "Created By",
    key: "creatorName",
    width: "45.33%",
    onCell: () => ({ className: "table-cell-padded" }),
    onHeaderCell: () => ({ className: "table-cell-padded" }),
  },
  {
    title: <div className="">Action</div>,
    key: "actions",
    width: "8%",
    onCell: () => ({ className: "table-cell-padded" }),
    onHeaderCell: () => ({ className: "table-cell-padded" }),
    render: (text, record) => {
      const popoverContent = (
        <div className="flex flex-col gap-[10px]">
          <Button
            onClick={() => {
              handleViewGroupClick(record?.groupId, record?.groupName);
              setVisiblePopover(null);
            }}
            onMouseEnter={() => setHoveredButton("view")}
            onMouseLeave={() => setHoveredButton(null)}
            className="navbar-item !w-[11rem]"
          >
            <span>View Users</span>
            {hoveredButton === "view" ? (
              <LottieIcon name="viewIcon" size={28} shouldPlay={true} />
            ) : (
              <img src={viewIcon} alt="view-icon" height={28} />
            )}
          </Button>


           <Button
            onClick={() => {
              // handleViewGroupClick(record?.groupId, record?.groupName);
              handleEditGroupName(record);
              setVisiblePopover(null);
            }}
            onMouseEnter={() => setHoveredButton("edit")}
            onMouseLeave={() => setHoveredButton(null)}
            className="navbar-item !w-[11rem]"
          >
            <span>Edit Name</span>
            {hoveredButton === "edit" ? (
              <LottieIcon name="editIcon" size={28} shouldPlay={true} />
            ) : (
              <img src={editIcon} alt="edit-icon" height={28} />
            )}
          </Button>

          <Button
            onClick={() => {
              handleViewGroupReportClick(record?.groupId, record?.groupName);
              setVisiblePopover(null);
            }}
            className="navbar-item !w-[11rem]"
            onMouseEnter={() => setHoveredButton("report")}
            onMouseLeave={() => setHoveredButton(null)}
          >
            <span>Report</span>
            {hoveredButton === "report" ? (
              <LottieIcon name="viewIcon" size={24} shouldPlay={true} />
            ) : (
              <img src={reportIcon} alt="report-icon" height={28} />
            )}
          </Button>

          {isActive && (
            <Button
            onClick={() => {
              setVisiblePopover(null);
              handleOpenConfirmDeletePopup(record);
            }}
            className="navbar-item !w-[11rem]"
            onMouseEnter={() => setHoveredButton("delete")}
            onMouseLeave={() => setHoveredButton(null)}
          >
            <span>Delete</span>
            {hoveredButton === "delete" ? (
              <LottieIcon name="trashIcon" size={24} shouldPlay={true} />
            ) : (
              <img src={deleteIcon} alt="delete-icon" height={28} />
            )}
          </Button>
          )}
        </div>
      );

      return (
        <CustomPopover
          content={popoverContent}
          trigger="click"
          className="admin-popover"
          placement="bottomRight"
          visible={visiblePopover === record.groupId}
          onVisibleChange={(visible) => {
            setVisiblePopover(visible ? record.groupId : null);
            if (!visible) setHoveredButton(null);
          }}
          getPopupContainer={() => document.body}
        >
          <img src={optionsIcon} alt="options-icon" height={24} />
        </CustomPopover>
      );
    },
  },
];

export const activeCurriculum = (
  visiblePopover,
  setVisiblePopover,
  hoveredButton,
  setHoveredButton,
  handleOpenConfirmDeletePopup,
  handleViewBundleClick,
  navigate,
  isActive
) => [
  
  {
    dataIndex: "bundleName",
    title: "Curriculum Name",
    key: "bundleName",
    width: "60.33%",
    onCell: () => ({ className: "table-cell-padded" }),
    onHeaderCell: () => ({ className: "table-cell-padded" }),
  },
  {
    title: "Action",
    key: "actions",
    width: "10.33%",
    align: "center",
    onCell: () => ({ className: "table-cell-padded" }),
    onHeaderCell: () => ({ className: "table-cell-padded" }),
    render: (text, record) => {
      const popoverContent = (
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            gap: "10px",
          }}
        >
          <Button
            className="navbar-item"
            onClick={() => {
              handleViewBundleClick(record?.id, record?.bundleName);
              setVisiblePopover(null);
            }}
            onMouseEnter={() => setHoveredButton("view")}
            onMouseLeave={() => setHoveredButton(null)}
            style={{ width: "11rem" }}
          >
            <span>View</span>
            {hoveredButton === "view" ? (
              <LottieIcon name="viewIcon" size={28} shouldPlay={true} />
            ) : (
              <img src={viewIcon} alt="view-icon" height={28} />
            )}
          </Button>

          <Button
            onClick={() => {
              navigate(`/bundles/bundle-report/${record?.id}`);
              setVisiblePopover(null);
            }}
            style={{ width: "11rem" }}
            className="navbar-item"
            onMouseEnter={() => setHoveredButton("report")}
            onMouseLeave={() => setHoveredButton(null)}
          >
            <span>Report</span>
            {hoveredButton === "report" ? (
              <LottieIcon name="viewIcon" size={28} shouldPlay={true} />
            ) : (
              <img src={viewIcon} alt="view-icon" height={28} />
            )}
          </Button>

          {isActive && (
            <Button
              className="navbar-item"
              onClick={() => { setVisiblePopover(null); handleOpenConfirmDeletePopup(record); }}
              onMouseEnter={() => setHoveredButton("delete")}
              onMouseLeave={() => setHoveredButton(null)}
              style={{ width: "11rem" }}
            >
              <span>Delete</span>
              {hoveredButton === "delete"
                ? <LottieIcon name="trashIcon" size={24} shouldPlay={true} />
                : <img src={deleteIcon} alt="delete-icon" height={28} />
              }
            </Button>
          )}
        </div>
      );

      return (
        <CustomPopover
          content={popoverContent}
          trigger="click"
          className="admin-popover"
          placement="bottomRight"
          visible={visiblePopover === record.id}
          onVisibleChange={(visible) => {
            setVisiblePopover(visible ? record.id : null);
            if (!visible) setHoveredButton(null);
          }}
          getPopupContainer={() => document.body}
        >
           <img src={optionsIcon} alt="options-icon" height={24} />
        </CustomPopover>
      );
    },
  },
];

export const getGroupReportColumns = ({ handleViewGroupClick }) => [

  {
    title: "Group Name",
    dataIndex: "groupName",
    key: "groupName",
    width: 200,
    render: (text, record) => (
      <Button
        type="link"
        onClick={() => handleViewGroupClick(record.groupId, record.groupName)}
        className="!p-0 !overflow-hidden !text-ellipsis !whitespace-nowrap !block !max-w-[180px] !text-[#910e11]"
        title={text}
      >
        {text}
      </Button>
    ),
  },
  {
    title: "Total Employees",
    dataIndex: "totalEmployees",
    key: "totalEmployees",
    width: 180,
  },
  {
    title: "Assigned Courses",
    dataIndex: "assignedCourses",
    key: "assignedCourses",
    width: 180,
  },
  {
    title: "Completed Employees",
    dataIndex: "completedEmployees",
    key: "completedEmployees",
    width: 200,
  },
  {
    title: "In Progress Employees",
    dataIndex: "inProgressEmployees",
    key: "inProgressEmployees",
    width: 200,
  },
  {
    title: "Not Started Employees",
    dataIndex: "notStartedEmployees",
    key: "notStartedEmployees",
    width: 200,
  },
  {
    title: "Employees Completed On Time",
    dataIndex: "employeesCompletedOnTime",
    key: "employeesCompletedOnTime",
    width: 250,
  },
  {
    title: "Employees Completed Late",
    dataIndex: "employeesCompletedLate",
    key: "employeesCompletedLate",
    width: 230,
  },
  {
    title: "On-Track Employees",
    dataIndex: "onTrackEmployees",
    key: "onTrackEmployees",
    width: 200,
  },
  {
    title: "Employees Behind Schedule",
    dataIndex: "employeesBehindSchedule",
    key: "employeesBehindSchedule",
    width: 230,
  },
  {
    title: "Employees Not Due Yet",
    dataIndex: "employeesNotDueYet",
    key: "employeesNotDueYet",
    width: 230,
  },
  {
    title: "Overdue Employees",
    dataIndex: "overdueEmployees",
    key: "overdueEmployees",
    width: 200,
  },
];

const renderProgress = (progress) => {
  const rounded = Number(progress?.toFixed(1));
  return (
    <Progress
      percent={rounded}
      size="small"
      type="circle"
      strokeColor={
        rounded >= 95 ? "#52c41a" : rounded >= 50 ? "#1890ff" : "#69c0ff"
      }
      format={(p) => `${p?.toFixed(1)}%`}
    />
  );
};

export const getGroupUserColumns = ({
  handleViewUserClick,
  handleAllocateCourse,
  handleOpenConfirmDeletePopup,
  visiblePopover,
  setVisiblePopover,
  hoveredButton,
  setHoveredButton,
}) => [
  { title: "Employee Id", dataIndex: "userName", key: "userName" },
  { title: "Name", dataIndex: "name", key: "name" },
  { title: "Email", dataIndex: "email", key: "email", width:250},
  { title: "Enrollments", dataIndex: "enrols", key: "enrols" },
  {
    title: "Completion %",
    dataIndex: "progress",
    key: "progress",
    render: renderProgress,
  },
  {
    title: "Actions",
    key: "actions",
    width: 90,
    align: "center",
    render: (_, record) => {
      const popoverContent = (
        <div className="flex flex-col gap-[10px]">
          <Button
            className="navbar-item"
            style={{ width: "11rem" }}
            onClick={() => {
              handleViewUserClick(record);
              setVisiblePopover(null);
            }}
            onMouseEnter={() => setHoveredButton("view")}
            onMouseLeave={() => setHoveredButton(null)}
          >
            <span>View History</span>
            {hoveredButton === "view" ? (
              <LottieIcon name="viewIcon" size={28} shouldPlay={true} />
            ) : (
              <img src={viewIcon} alt="view-icon" height={28} />
            )}
          </Button>

          <Button
            className="navbar-item"
            style={{ width: "11rem" }}
            onClick={() => {
              handleAllocateCourse(record);
              setVisiblePopover(null);
            }}
            onMouseEnter={() => setHoveredButton("allocate")}
            onMouseLeave={() => setHoveredButton(null)}
          >
            <span>Allocate Course</span>
            {hoveredButton === "allocate" ? (
              <LottieIcon name="allocateIcon" size={24} shouldPlay={true} />
            ) : (
              <img src={viewIcon} alt="allocate-icon" height={28} />
            )}
          </Button>

          <Button
            className="navbar-item"
            style={{ width: "11rem" }}
            onClick={() => {
              setVisiblePopover(null);
              handleOpenConfirmDeletePopup(record);
            }}
            onMouseEnter={() => setHoveredButton("delete")}
            onMouseLeave={() => setHoveredButton(null)}
          >
            <span>Delete</span>
            {hoveredButton === "delete" ? (
              <LottieIcon name="trashIcon" size={24} shouldPlay={true} />
            ) : (
              <img src={deleteIcon} alt="delete-icon" height={28} />
            )}
          </Button>
        </div>
      );

      return (
        <CustomPopover
          content={popoverContent}
          trigger="click"
          className="admin-popover"
          placement="bottomRight"
          visible={visiblePopover === record.id}
          onVisibleChange={(visible) => {
            setVisiblePopover(visible ? record.id : null);
            if (!visible) setHoveredButton(null);
          }}
          getPopupContainer={() => document.body}
        >
          <img src={optionsIcon} alt="options-icon" height={24} />
        </CustomPopover>
      );
    },
  },
];

export const getGroupCourseColumns = ({ handleViewUserClick, courseFilter }) =>
  [
    { title: "Name", dataIndex: "name", key: "name" },
    { title: "Enrollments", dataIndex: "enrols", key: "enrols" },
    {
      title: "Completion %",
      dataIndex: "progress",
      key: "progress",
      render: renderProgress,
    },
    courseFilter === "all"
      ? {
          title: "Type",
          dataIndex: "type",
          key: "type",
          render: (type) => (
            <Tag
              className={type === "Bundle" ? "tag tag-bundle" : "tag tag-error"}
            >
              {type}
            </Tag>
          ),
        }
      : null,
    {
      title: "Actions",
      key: "actions",
      render: (_, record) => (
        <CustomButton
          variant="outlined"
          onClick={() => handleViewUserClick(record)}
        >
          View
        </CustomButton>
      ),
    },
  ].filter(Boolean);

export const LEARNER_COLUMNS = [
  { title: "Learner", dataIndex: "displayTitle", key: "displayTitle" },
  { title: "Progress", dataIndex: "progress", key: "progress" },
  { title: "Status", dataIndex: "status", key: "status", render: renderStatus },
  { title: "Adherence", dataIndex: "adherence", key: "adherence" },
];

const COMMON_COLUMNS_REPORT = [
  {
    title: "Assigned At",
    dataIndex: "assignedAt",
    key: "assignedAt",
    render: formatDate,
    
  },
  {
    title: "Deadline",
    dataIndex: "deadline",
    key: "deadline",
    render: formatDate,
  },
  {
    title: "Progress",
    dataIndex: "courseCompletionPercentage",
    key: "courseCompletionPercentage",
    render: renderProgress,
    sorter: (a, b) =>
      a.courseCompletionPercentage - b.courseCompletionPercentage,
  },
  {
    title: "Status",
    dataIndex: "status",
    key: "status",
    render: renderStatus,
  },
  {
    title: "Adherence",
    dataIndex: "adherence",
    key: "adherence",
  },
];

const TITLE_MAP = { ALL: "Title", COURSE: "Course", BUNDLE: "Curriculum" };

export const getDynamicColumnsReport = ({ subType }) => [
  {
    title: TITLE_MAP[subType] ?? "Title",
    dataIndex: "displayTitle",
    key: "displayTitle",
  },
  {
    title: "Type",
    dataIndex: "type",
    key: "type",
  },
  ...COMMON_COLUMNS_REPORT,
];

export const LEVEL_STYLES = {
  BEGINNER: "text-emerald-600 bg-emerald-50 border border-emerald-200",
  INTERMEDIATE: "text-amber-600 bg-amber-50 border border-amber-200",
  ADVANCED: "text-rose-600 bg-rose-50 border border-rose-200",
};

export const LEVEL_FILTERS = ["BEGINNER", "INTERMEDIATE", "ADVANCED"].map((v) => ({
  text: v,
  value: v,
}));


export const LevelBadge = ({ level }) => (
  <span
    className={`inline-flex items-center justify-center w-32 px-4 py-1.5 rounded-lg border font-medium text-sm
      ${LEVEL_STYLES[level] ?? "text-gray-600 bg-gray-100 border-gray-200"}`}
  >
    {level}
  </span>
);

export const getUserQuizReportColumns = (users, selectedUser, fetchDetailedAttempts) => [
  {
    title: "Course Title",
    dataIndex: ["courseOutDTO", "title"],
    sorter: (a, b) => a.courseOutDTO.title.localeCompare(b.courseOutDTO.title),
  },
  {
    title: "Level",
    dataIndex: ["courseOutDTO", "level"],
    filters: LEVEL_FILTERS,
    onFilter: (value, record) => record.courseOutDTO.level === value,
    render: (level) => <LevelBadge level={level} />,
  },
  {
    title: "Created At",
    dataIndex: ["courseOutDTO", "createdAt"],
    render: (text) => new Date(text).toLocaleDateString(),
    sorter: (a, b) =>
      new Date(a.courseOutDTO.createdAt) - new Date(b.courseOutDTO.createdAt),
  },
  {
    title: "Action",
    key: "action",
    width: 150,
    render: (_, record) => (
      <Button
        type="default"
        icon={<EyeOutlined />}
        onClick={() =>
          fetchDetailedAttempts(selectedUser, record.courseOutDTO.courseId)
        }
      >
        View Quiz Details
      </Button>
    ),
  },
];

export const getCourseQuizReportColumns = (courses, selectedCourse, fetchDetailedAttempts) => [
  {
    title: "User Name",
    dataIndex: "userName",
    sorter: (a, b) => a.userName.localeCompare(b.userName),
  },
  {
    title: "First Name",
    dataIndex: "firstName",
    sorter: (a, b) => a.firstName.localeCompare(b.firstName),
  },
  {
    title: "Last Name",
    dataIndex: "lastName",
    sorter: (a, b) => a.lastName.localeCompare(b.lastName),
  },
  {
    title: "Attempts",
    dataIndex: ["latestAttempt", "quizAttempt", "attempt"],
    sorter: (a, b) =>
      (a.latestAttempt?.quizAttempt?.attempt ?? 0) -
      (b.latestAttempt?.quizAttempt?.attempt ?? 0),
  },
  {
    title: "Action",
    key: "action",
    width: 150,
    render: (_, record) => (
      <Button
        type="link"
        icon={<EyeOutlined />}
        onClick={() =>
          fetchDetailedAttempts(record.userId, selectedCourse)
        }
      >
        View Quiz Details
      </Button>
    ),
  },
];

export const getBundleMemberColumns = () => [
  { title: "User",      dataIndex: "fullName" },
  { title: "Progress",  dataIndex: "avgProgress",    render: formatPercentage },
  { title: "Status",    dataIndex: "bundleStatus",   render: (val) => StatusTag(val) },
  { title: "Adherence", dataIndex: "worstAdherence" },
];


export const getMemberCourseColumns = () => [
  { title: "Course",    dataIndex: "courseTitle",                key: "courseTitle" },
  { title: "Progress",  dataIndex: "courseCompletionPercentage", key: "courseCompletionPercentage", render: formatPercentage },
  { title: "Status",    dataIndex: "status",                     key: "status",    render: (val) => StatusTag(val) },
  { title: "Adherence", dataIndex: "adherence",                  key: "adherence" },
  { title: "Quiz",      dataIndex: "quizResult",                 key: "quizResult" },
];